import { Instance, types } from 'mobx-state-tree';

export const UserIamRole = types.model(
  'UserIamRole',
  {
    projectId: types.string,
    roles: types.array(types.string)
  }
);

export interface IUserIamRole extends Instance<typeof UserIamRole> {
}
